import { registerFeatureTranslations } from '@/core/i18n';
import type { TranslationSchema } from '@/core/types/translation.types';
import es from './es.json';
import en from './en.json';

export function registerWorkSchedulesTranslations() {
  registerFeatureTranslations<TranslationSchema>('workSchedules', { es, en });
}
